import React from 'react';
import { Route } from 'react-router-dom';
import { APP_ROUTES } from '../shared/config/routes-config';
import OperationContainer from './Operation';

export const OperationModule = () => (
  <Route exact path={APP_ROUTES.OPERATION_MODULE.PATH} component={OperationContainer} />
);
